// ════════════════════════════════════════════════════════════════════════
//  Wer eine Fassung angefangen hat, in Worten
//
//  `created_by` ist eine Kennung. Auf dem Bildschirm hat eine Kennung nichts
//  verloren: sie beantwortet die Frage nicht, die davorsteht - „kann ich hier
//  arbeiten, und wenn nicht, wen frage ich?“.
//
//  DIE EIGENE ARBEIT HEISST „VON IHNEN“
//
//  Und nicht die eigene Adresse. Wer seinen eigenen Entwurf ansieht, weiß, wem
//  er gehört; die Adresse dort noch einmal zu lesen ist Papier ohne Aussage. Der
//  Unterschied, auf den es ankommt, ist „meiner“ gegen „nicht meiner“.
//
//  UNBEKANNT WIRD VERSCHWIEGEN, NICHT BEHAUPTET
//
//  `created_by` ist nullable: Bestandszeilen von vor der Spalte und Seeds haben
//  keinen Urheber. „angefangen von unbekannt“ klänge nach einem Fehler, wo
//  nichts kaputt ist - dann steht eben nichts da. Dasselbe gilt, solange die
//  Namen noch geladen werden: lieber eine Zeile später als eine falsche jetzt.
// ════════════════════════════════════════════════════════════════════════

/** Die Redaktion, wie `editorial_people()` sie herausgibt. */
export type Person = {
  readonly userId: string;
  readonly label: string;
};

/**
 * Wer diese Fassung angefangen hat – oder null, wenn dazu nichts zu sagen ist.
 *
 * Ohne „angefangen von“ davor: der Satz baut sich an der Stelle, an der er
 * steht. In der Fassungsleiste steht er hinter „aus Fassung 13“, in der Liste
 * in einer Klammer.
 */
export function whoStarted(
  createdBy: string | null,
  ownUserId: string,
  people: readonly Person[] | undefined,
): string | null {
  if (createdBy === null) return null;
  if (createdBy === ownUserId) return "Ihnen";
  return people?.find((person) => person.userId === createdBy)?.label ?? null;
}
